// extracted by mini-css-extract-plugin
module.exports = {"grid__container":"GridContainer_grid__container__uk3lW","grid":"GridContainer_grid__2tMY4","one_column_on_mobile":"GridContainer_one_column_on_mobile__1KqtP"};